import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { PieChart as PieChartIcon } from '@mui/icons-material';
import {
  GoldBarIcon, GoldStockIcon, BitcoinIcon, BitcoinStockIcon, freedomIcon
} from '../utils/constants';

const chartOptions = [
  { value: 'keyAssets', icon: '💰', label: '關鍵投資品' },
  { value: 'oil', icon: '🛢️', label: '美債石油' },
  { value: 'gold', icon: <GoldBarIcon/>, label: '美債黃金' },
  { value: 'bitcoin', icon: <BitcoinIcon size={18} />, label: '美債比特幣' },
  { value: 'usd', icon: '💵', label: '美債美元' },
  { value: 'usStocks', icon: '📈', label: '美債美股' },
  { value: 'stockGold', icon: <GoldStockIcon/>, label: '美股黃金' },
  { value: 'stockBitcoin', icon: <BitcoinStockIcon size={18} />, label: '美股比特幣' },
  { value: 'sentiment', icon: '😱', label: '市場情緒' },
  { value: 'usJobs', icon: '👷', label: '美國非農數據' },
  { value: 'chinaPBOC', icon: '🇨🇳', label: '中國社融數據' },
  { value: 'usDebt', icon: '🏦', label: '美國國債數據' },
  { value: 'trade', icon: '🌏', label: '中美貿易數據' },
  { value: 'usGDP', icon: '🏗️', label: '美國GDP數據' },
  { value: 'rareEarth', icon: '🪨', label: '中國稀土數據' },
  { value: 'forex', icon: '💱', label: '美元萬國匯率' },
  { value: 'marketShare', icon: <PieChartIcon fontSize="small"/>, label: '一籃子貨幣' },
  { value: 'freedom', icon: freedomIcon, label: '自由組合' },
];

export default function ChartTypeSelector({ chartType, onChartTypeChange, onRangeReset }) {
  const handleChange = (e) => {
    const newChartType = e.target.value;
    onChartTypeChange(newChartType);
    
    // 根据图表类型重置范围
    if (["usJobs", "chinaPBOC", "trade", "usGDP", "rareEarth"].includes(newChartType)) {
      onRangeReset(365 + 31); // 非農數據默認範圍為 1 年
    } else {
      onRangeReset(30); // 每次切換圖表類型時重置範圍
    }
  };

  return (
    <Box
      sx={{
        position: "absolute",
        top: 16,
        right: 16,
        zIndex: 10,
      }}
    >
      <FormControl 
        size="small" 
        sx={{ 
          minWidth: 180,
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(0, 0, 0, 0.08)',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 1)',
              boxShadow: '0 6px 25px rgba(0, 0, 0, 0.15)',
              transform: 'translateY(-1px)',
            },
            '&.Mui-focused': {
              backgroundColor: 'rgba(255, 255, 255, 1)',
              boxShadow: '0 6px 25px rgba(0, 0, 0, 0.15)',
              borderColor: '#1976d2',
            }
          },
          '& .MuiInputLabel-root': {
            fontWeight: 500,
            color: '#666',
            '&.Mui-focused': {
              color: '#1976d2',
            }
          },
          '& .MuiSelect-icon': {
            color: '#666',
            transition: 'transform 0.3s ease',
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiSelect-icon': {
            transform: 'rotate(180deg)',
          }
        }}
      >
        <InputLabel 
          id="chart-select-label"
          sx={{ 
            fontSize: '14px',
            fontWeight: 500
          }}
        >
          📊 數據類別
        </InputLabel>
        <Select
          labelId="chart-select-label"
          value={chartType}
          label="📊 數據類別"
          onChange={handleChange}
          sx={{
            fontSize: '14px',
            fontWeight: 500,
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                borderRadius: '12px',
                border: '1px solid rgba(0, 0, 0, 0.08)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                mt: 1,
                '& .MuiMenuItem-root': {
                  borderRadius: '8px',
                  margin: '4px 8px',
                  transition: 'all 0.2s ease',
                  fontSize: '14px',
                  fontWeight: 500,
                  '&:hover': {
                    backgroundColor: 'rgba(25, 118, 210, 0.08)',
                    transform: 'translateX(4px)',
                  },
                  '&.Mui-selected': {
                    backgroundColor: 'rgba(25, 118, 210, 0.12)',
                    color: '#1976d2',
                    fontWeight: 600,
                    '&:hover': {
                      backgroundColor: 'rgba(25, 118, 210, 0.16)',
                    }
                  }
                }
              }
            }
          }}
        >
          {chartOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>{option.icon}</span>
                {option.label}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}